module.exports = __webpack_public_path__ + "static/media/MHRP09N0021.4858820e.svg";